import React from "react";
import Card from "components/card";
import {
    FileText,
} from "lucide-react"

const NoDocument = ({
    docType
}) => {
    return (
        <Card className="bg-white text-slate-900 flex flex-col gap-6 rounded-2xl border-2 border-dashed border-slate-300 dark-mode-card">
            <div className="px-6 pb-6 flex flex-col items-center justify-center py-12 text-center">
                <FileText className="w-16 h-16 mb-4 opacity-50 muted-text" />
                <h4 className="text-[16px] font-semibold mb-2 title-text">
                    No {docType} Documents Found
                </h4>
            </div>
        </Card>
    )
};
export default NoDocument;